<jhi-bary-card titleKey="transport-edi-history.title">
  <div class="col-12" body>
    <div class="row" *ngFor="let ediHistory of ediHistories; let index = index">
      <div class="col">
        <p>
          <jhi-bary-icon icon="check" [faDirective]="FAS" class="color-success mr-1"></jhi-bary-icon>
          {{ writeLine(ediHistory, index) }}
        </p>
      </div>
      <div class="col-auto" *ngIf="displayDownloadEdiFile">
        <a (click)="downloadEdiFile(ediHistory)">
          <p>
            <jhi-bary-icon icon="cloud-download-alt" [faDirective]="FAS"></jhi-bary-icon>
          </p>
        </a>
      </div>
    </div>
  </div>
</jhi-bary-card>
